module.exports = __webpack_public_path__ + "media/images/top/img_pickup_sclabo-165b5d7ef696f2ecbc5919bde33eb29c.webp";